import { styled as o } from "styled-components";
import { Colors as r } from "../../../../styles/colors/index.js";
import { Theme as t } from "../../../../styles/themes/index.js";
import { SmallLight as a } from "../../../../styles/typography/index.js";
import { SupercashbackTag as i } from "../SupercashbackTag/index.js";
const l = o.div`
  display: flex;
  flex-direction: column;
  width: max-content;
  text-align: center;

  &[data-visible='false'] {
    display: none;
  }
`, n = o(i)`
  border-bottom-right-radius: 0;
`, p = o.span`
  ${a}
  padding: 4px 8px;
  border-bottom-right-radius: 8px;
  background: rgb(${t.colors.Brand});
  color: rgb(${r.White});
`;
export {
  p as CashbackValueTag,
  n as CustomSupercashbackTag,
  l as Tag
};
